import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  HolidayPlanInfo,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import TextField from "../../../../../Component/Material-ui/TextField";
import createstore from "../../../../../store";
import { getFormattedDate } from "../../../../../Utils";
import "./holiday.css";

const localizer = momentLocalizer(moment);

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
  colorSwitchBase: {
    color: "#166ab3",
    "&$colorChecked": {
      color: "#166ab3",
      "& + $colorBar": {
        backgroundColor: "#666",
      },
    },
    height: 20,
  },
});

class CustomToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.date),
    };
  }

  render() {
    const { label } = this.props;
    return (
      <div className="rbc-toolbar">
        <div className="calender-head">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            onClick={() => this.props.onNavigate("PREV")}
          >
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill="#fff"
              d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
            />
          </svg>
          <label className="label-date">{label}</label>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            onClick={() => this.props.onNavigate("NEXT")}
          >
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
              fill="#fff"
              d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
            />
          </svg>
        </div>
      </div>
    );
  }
}

class HolidayPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      holiday: [],
      customHolidayList: [],
      holidayname: "",
      ismandatory: true,
      isrequiremandatory: false,
      isrequireoptional: false,
      isDisable: false,
      ErEventName: false,
      prevDate: "",
      selectedDate: new Date(),
      defaultDate: new Date(),
      isChecked: false,
      ErUniqueName: false,
      maxDate: new Date(),
      minDate: new Date(),
      editflag: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.checkUnique = this.checkUnique.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("holidayplan");
    const { SubscriptionInfo } = createstore.getState();
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.holidayplan) {
      const text = this.props.Language.holidayplan.HtHolidayPlan;
      this.props.setHelperText({ helperText: text });
    }
    this.GetInfoFromLocalStorage();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(3, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  GetInfoFromLocalStorage() {
    const HolidayInfo = this.props.holidayPlanReducer;
    if (!this.isEmpty(HolidayInfo)) {
      let holiday = [];
      if (HolidayInfo.holiday) {
        HolidayInfo.holiday.length > 0
          ? (holiday = HolidayInfo.holiday)
          : (holiday = []);
      }
      const isrequiremandatory = HolidayInfo.isrequiremandatory == true;
      const isrequireoptional = HolidayInfo.isrequireoptional == true;

      const { holidayyear } = HolidayInfo;

      const defaultDate = new Date(holidayyear, 0, 1);
      const selectedDate = new Date(holidayyear, 0, 1);
      const minDate = new Date(holidayyear, 0, 0);
      const maxDate = new Date(holidayyear, 11, 32);
      this.setState(
        {
          holiday,
          holidayyear,
          defaultDate,
          selectedDate,
          isrequiremandatory,
          isrequireoptional,
          minDate,
          maxDate,
        },
        () => {
          this.UpdateCustomHolidayList();
          this.UpdateSwitchButtonState();
        },
      );
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateSwitchButtonState() {
    // this.state.isrequiremandatory =  false,
    // this.state.isrequireoptional = false
    let isChecked;
    let ismandatory;
    let isDisable;

    // if(this.state.isrequiremandatory == false){
    //     ismandatory = true
    //     isDisable = true
    // }
    // if(this.state.isrequireoptional == false){
    //     ismandatory = false
    //     isDisable = true
    // }
    // if(this.state.isrequiremandatory == true && this.state.isrequireoptional == true){
    //     ismandatory = false
    //     isDisable = false
    // }

    if (this.state.isrequiremandatory == false) {
      isChecked = true;
      ismandatory = false;
      isDisable = true;
    }
    if (this.state.isrequireoptional == false) {
      isChecked = false;
      ismandatory = true;
      isDisable = true;
    }
    if (
      this.state.isrequiremandatory == true &&
      this.state.isrequireoptional == true
    ) {
      isChecked = false;
      ismandatory = true;
      isDisable = false;
    }
    this.setState({ ismandatory, isDisable, isChecked });
  }

  GetParticularEvent(event) {
    const { holidayid } = event;
    const holidayname = event.title;
    const selectedDate = event.start;
    const { ismandatory } = event;
    let isChecked;
    const editflag = true;
    event.ismandatory == false ? (isChecked = true) : (isChecked = false);
    this.setState({
      holidayname,
      ismandatory,
      selectedDate,
      holidayid,
      isChecked,
      editflag,
    });
  }

  UpdateCustomHolidayList() {
    const { customHolidayList } = this.state;
    // this.state.selectedDate

    if (this.state.holiday.length > 0) {
      this.state.holiday.forEach((option) => {
        const holidaydate = option.holidaydate.split("-");
        const year = holidaydate[0];
        const month = holidaydate[1];
        const day = holidaydate[2];
        const obj = {
          holidayid: option.holidayid ? option.holidayid : 0,
          title: option.holidayname,
          start: new Date(year, month - 1, day),
          end: new Date(year, month - 1, day),
          ismandatory: option.ismandatory,
        };
        customHolidayList.push(obj);
      });
    }
    this.setState({ customHolidayList });
  }

  OnNameChange(e) {
    let ErEventName;
    e.target.value ? (ErEventName = false) : (ErEventName = true);
    this.setState({
      holidayname: e.target.value,
      ErEventName,
      ErUniqueName: false,
    });
  }

  checkUnique(e) {
    if (this.state.holiday.find((h) => h.holidayname == e)) {
      this.props.enqueueSnackbar("Please fill the unique holiday name", {
        variant: "error",
      });
      this.setState({ holidayname: "", ErUniqueName: false });
    }
  }

  handleChange = () => (event) => {
    console.log("event: ", event);

    let ismandatory;
    let isChecked;
    if (event.target.checked == false) {
      ismandatory = true;
      isChecked = false;
    } else {
      ismandatory = false;
      isChecked = true;
    }
    this.setState({ ismandatory, isChecked });
  };

  ConvertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  UpdateHolidayArray() {
    const holiday = [];
    const { customHolidayList } = this.state;
    for (const listItem of customHolidayList) {
      const date = this.ConvertDate(listItem.start);
      // let ismandatory
      // listItem.ismandatory == false ? ismandatory = true : ismandatory = false
      const obj = {
        holidayid: listItem.holidayid,
        holidayname: listItem.title,
        holidaydate: date,
        ismandatory: listItem.ismandatory,
      };
      // let index = holiday.findIndex(x=> x.holidayid == listItem.holidayid)
      // index != -1  ? holiday[index] = obj : holiday.push(obj)
      holiday.push(obj);
    }
    this.setState({ holiday }, () => {
      this.UpdateHolidayPlanInfoReducer();
    });
  }

  AddHolidayInfo() {
    if (this.state.holidayname) {
      if (!/[a-zA-Z]/.test(this.state.holidayname)) {
        this.setState({ ErEventName: true });
        return;
      }

      const filteredArray = this.state.customHolidayList.filter((x) => {
        const date = moment(x.start).format("YYYY-MM-DD");
        const selectedDate = moment(this.state.selectedDate).format(
          "YYYY-MM-DD",
        );
        return date == selectedDate && x.title == this.state.holidayname;
      });
      if (this.state.customHolidayList.length > 0) {
        const findex = this.state.customHolidayList.findIndex(
          (x) => x.start.valueOf() == this.state.selectedDate.valueOf(),
        );
        if (findex != -1) {
          if (
            this.state.customHolidayList[findex].ismandatory !=
              this.state.ismandatory &&
            this.state.customHolidayList[findex].start.valueOf() ==
              this.state.defaultDate.valueOf()
          ) {
            this.props.enqueueSnackbar(
              "You can't apply both preferences on the same day",
              { variant: "error" },
            );
            return;
          }
        }
      }

      if (filteredArray.length > 0 && this.state.editflag == false) {
        this.setState({ ErUniqueName: true });
      } else {
        this.setState({ ErUniqueName: false, editflag: false });
        const { customHolidayList } = this.state;
        const selectedDate = moment(this.state.selectedDate).format(
          "YYYY-MM-DD",
        );
        const holidaydate = selectedDate.split("-");
        const year = holidaydate[0];
        const month = holidaydate[1];
        const day = holidaydate[2];

        // let ismandatory
        // this.state.ismandatory == false ? ismandatory = true : ismandatory = false
        const obj = {
          holidayid: this.state.holidayid,
          title: this.state.holidayname,
          start: new Date(year, month - 1, day),
          end: new Date(year, month - 1, day),
          ismandatory: this.state.ismandatory,
        };

        const index = customHolidayList.findIndex(
          (x) =>
            x.holidayid == this.state.holidayid &&
            x.start == this.state.selectedDate,
        );
        if (index == -1) {
          customHolidayList.push(obj);
        } else {
          customHolidayList[index] = obj;
        }
        if (this.state.isrequiremandatory) {
          this.setState(
            {
              customHolidayList,
              holidayname: "",
              holidayid: null,
              ErEventName: false,
              isChecked: false,
              ismandatory: true,
              editflag: false,
            },
            () => {
              this.UpdateHolidayArray();
            },
          );
        } else {
          this.setState(
            {
              customHolidayList,
              holidayname: "",
              holidayid: null,
              ErEventName: false,
              isChecked: true,
              ismandatory: false,
              editflag: false,
            },
            () => {
              this.UpdateHolidayArray();
            },
          );
        }
      }
    } else {
      this.setState({ ErEventName: true, editflag: false });
    }
  }

  AreYouSure(obj) {
    const { customHolidayList } = this.state;
    const index = customHolidayList.findIndex(
      (x) => x.start == obj.start && x.holidayid == obj.holidayid,
    );
    obj.isDelete = true;
    customHolidayList[index] = obj;
    this.setState({ customHolidayList });
  }

  OnCancel(obj) {
    const { customHolidayList } = this.state;
    const index = customHolidayList.findIndex(
      (x) => x.start == obj.start && x.holidayid == obj.holidayid,
    );
    obj.isDelete = false;
    customHolidayList[index] = obj;
    this.setState({ customHolidayList });
  }

  DeleteHolidayInfo(obj) {
    const { customHolidayList } = this.state;
    const index = customHolidayList.findIndex(
      (x) => x.start == obj.start && x.holidayid == obj.holidayid,
    );
    customHolidayList.splice(index, 1);
    this.setState(
      {
        customHolidayList,
        holidayname: "",
        holidayid: null,
        isChecked: false,
      },
      () => {
        this.UpdateHolidayArray();
      },
    );
  }

  UpdateHolidayPlanInfoReducer() {
    const holidayPlanInfo = this.props.holidayPlanReducer;
    holidayPlanInfo.holiday = this.state.holiday;
    this.props.HolidayPlanInfo({ ...holidayPlanInfo });
  }

  OnNext = () => {
    this.UpdateHolidayPlanInfoReducer();
    this.props.click();
  };

  eventStyleGetter(event) {
    let style;
    if (event.ismandatory == true) {
      style = {
        backgroundColor: "#50e3c2",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    }
    if (event.ismandatory == false) {
      style = {
        backgroundColor: "#f5a623",
        color: "#fff",
        border: "0px",
        display: "block",
      };
    }
    return {
      style,
    };
  }

  Navigate(selectedDate) {
    this.HelperSliderFlag(["HtCalenderDateSelection"]);
    if (
      new Date(this.state.minDate) < new Date(selectedDate) &&
      new Date(this.state.maxDate) > new Date(selectedDate)
    ) {
      this.setState({
        holidayname: "",
        defaultDate: selectedDate,
        selectedDate,
      });
    }
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Langugae.holidayplan[${HtField}]`);
    //  let text = this.props.Language.holidayplan[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;

    let currentMonthEvents = [];
    let selectedDate = moment(this.state.selectedDate).format("YYYY-MM-DD");
    selectedDate = selectedDate.split("-");
    const selectedYear = selectedDate[0];
    const selectedMonth = selectedDate[1];
    currentMonthEvents = this.state.customHolidayList.filter((x) => {
      let date = moment(x.start).format("YYYY-MM-DD");
      date = date.split("-");
      const year = date[0];
      const month = date[1];
      return year == selectedYear && month == selectedMonth;
    });
    // // console.log(currentMonthEvents)
    const language = this.props.Language.holidayplan;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <div className="stepper-scroller padding-top-8 width100">
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                sm={12}
                className="padding20 holiday-calendar"
              >
                <div>
                  <p className="add-label-active">
                    <FormattedMessage
                      id="Lbholidayplan"
                      defaultMessage="Holiday Plan"
                    />
                  </p>
                  <BigCalendar
                    localizer={localizer}
                    events={this.state.customHolidayList}
                    defaultDate={this.state.defaultDate}
                    date={this.state.defaultDate}
                    onSelectEvent={this.GetParticularEvent.bind(this)}
                    onSelectSlot={(slotInfo) => this.handleSelect(slotInfo)}
                    // selected={(this.SelectDate.bind(this))}
                    // onSelectSlot={((slot) => // console.log(slot))}
                    step={60}
                    view="month"
                    views={["month"]}
                    min={this.state.maxDate}
                    max={this.state.minDate}
                    // min={new Date(this.state.holidayyear, 0, 1)}
                    // min={new Date(2019, 0, 1)}
                    // max={new Date(2019, 11, 31)}
                    // startAccessor='startDate'
                    // endAccessor='endDate'
                    // timeslots={1}
                    // components={{
                    //     event: EventComponent
                    // }}
                    eventPropGetter={this.eventStyleGetter.bind(this)}
                    components={{ toolbar: CustomToolbar }}
                    onNavigate={(date, view, action) =>
                      this.Navigate(date, view, action)
                    }
                    // onNavigate={(date) => { this.setState({ holidayname : '', selectedDate: date })}}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6} sm={12} className="padding20">
                <div>
                  <div>
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbholidayName"
                        defaultMessage="Holiday Name"
                      />
                    </p>
                    <div className="margin-bottom-20">
                      <TextField
                        autoComplete="off"
                        autoFocus
                        placeholder="Holiday Name"
                        onFocus={this.HelperSliderFlag.bind(
                          this,
                          "HtHolidayName",
                        )}
                        onChange={this.OnNameChange.bind(this)}
                        value={this.state.holidayname}
                        onBlur={(e) => this.checkUnique(e.target.value)}
                        maxLength="50"
                        variant="outlined"
                      />
                    </div>
                  </div>
                  <div>
                    {this.state.ErEventName == true ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErEventName"
                          defaultMessage="Please Enter Holiday Name"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                    {this.state.ErUniqueName == true ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErUniqueName"
                          defaultMessage="Duplicate Holiday Name"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="inline-display" align="center">
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbholidayPreference"
                        defaultMessage="Holiday Preference"
                      />
                    </p>
                    <div
                      className={
                        this.state.isrequiremandatory == false
                          ? "disabledText inline-display"
                          : "inline-display"
                      }
                    >
                      <p className="add-label-active">
                        <FormattedMessage
                          id="LbMandatory"
                          defaultMessage="Mandatory"
                        />
                      </p>
                    </div>
                    <div className="inline-display">
                      <FormControlLabel
                        className="align-center"
                        control={
                          <Switch
                            checked={this.state.isChecked}
                            onChange={this.handleChange()}
                            value={this.state.isChecked}
                            color="primary"
                            classes={{
                              switchBase: classes.colorSwitchBase,
                              checked: classes.colorChecked,
                              bar: classes.colorBar,
                            }}
                            className="disabledswitch"
                          />
                        }
                      />
                    </div>
                    <div
                      className={
                        this.state.isrequireoptional == false
                          ? "disabledText inline-display"
                          : "inline-display"
                      }
                    >
                      <p className="add-label-active">
                        <FormattedMessage
                          id="LbOptional"
                          defaultMessage="Optional"
                        />
                      </p>
                    </div>
                  </div>
                  <div className="margin-top-15">
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={this.AddHolidayInfo.bind(this)}
                    >
                      <FormattedMessage id="BtSave" defaultMessage="Save" />
                    </Button>
                  </div>
                  <div className="margin-top-20">
                    <p className="add-label-active">
                      <FormattedMessage
                        id="LbholidaysInThisMonth"
                        defaultMessage="Holidays in this month"
                      />
                    </p>

                    {currentMonthEvents.map((obj) => (
                      <div className="holiday-info-list">
                        <Grid container className="margin-bottom-10">
                          <Grid
                            item
                            xs={12}
                            md={8}
                            sm={8}
                            className="position-rel"
                          >
                            <div className="holiday-type">
                              {obj.ismandatory == true ? (
                                <div className="ismandatory-date">M</div>
                              ) : (
                                <div className="optional-date">O</div>
                              )}
                            </div>
                            <div
                              className="inline-display margin-left-10 position-abs cursour-pointer"
                              onClick={this.GetParticularEvent.bind(this, obj)}
                            >
                              <p className="nomargin">
                                {/* <Tooltip title={obj.title} placement="top"> */}
                                {obj.title}
                                {/* </Tooltip> */}
                              </p>
                              <p className="nomargin">
                                {getFormattedDate(obj.start)}
                              </p>
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={4}
                            sm={4}
                            className="position-rel"
                          >
                            {obj.isDelete == true ? (
                              <span className="holyday-delete-details">
                                <span className="save-details-confirm">
                                  <FormattedMessage
                                    id="LbAreYouSure"
                                    defaultMessage="Are you sure?"
                                  />
                                </span>
                                <span
                                  className="cursour-pointer active-color"
                                  onClick={this.DeleteHolidayInfo.bind(
                                    this,
                                    obj,
                                  )}
                                >
                                  <svg
                                    className="message-edit cursour-pointer save-icon"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="#166ab3"
                                      d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
                                    ></path>
                                  </svg>
                                </span>
                                <span
                                  className="cursour-pointer active-color"
                                  onClick={this.OnCancel.bind(this, obj)}
                                >
                                  <svg
                                    className="message-edit cursour-pointer close-icon"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    onClick={this.OnCancel.bind(this, obj)}
                                  >
                                    <path
                                      fill="#166ab3"
                                      d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                                    ></path>
                                  </svg>
                                </span>
                              </span>
                            ) : (
                              ""
                            )}
                            <div className="floatright">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="#166ab3"
                                className="cursour-pointer"
                                onClick={this.AreYouSure.bind(this, obj)}
                              >
                                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z" />
                              </svg>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    ))}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

HolidayPlan.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      HolidayPlanInfo: (data) => HolidayPlanInfo(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(HolidayPlan)));
